module.exports = __webpack_public_path__ + "static/media/dice-warrior.2a81eb3c.jpg";